var map = {
	"./": [
		312,
		9
	],
	"./ExternalGameById": [
		1128,
		9,
		117
	],
	"./ExternalGameById.dictionary": [
		336,
		3
	],
	"./ExternalGameById.dictionary.json": [
		336,
		3
	],
	"./ExternalGameById.explanation": [
		1130,
		9,
		118
	],
	"./ExternalGameById.explanation.ts": [
		1130,
		9,
		118
	],
	"./ExternalGameById.module.scss": [
		1129,
		9,
		278
	],
	"./ExternalGameById.tsx": [
		1128,
		9,
		117
	],
	"./ExternalGameByIdDeferred": [
		361,
		9
	],
	"./ExternalGameByIdDeferred.tsx": [
		361,
		9
	],
	"./components/IframeErrorAlert": [
		970,
		9,
		51
	],
	"./components/IframeErrorAlert/": [
		970,
		9,
		51
	],
	"./components/IframeErrorAlert/IframeErrorAlert.dictionary": [
		1034,
		3,
		176
	],
	"./components/IframeErrorAlert/IframeErrorAlert.dictionary.json": [
		1034,
		3,
		176
	],
	"./components/IframeErrorAlert/IframeErrorAlert.module.scss": [
		1081,
		9,
		306
	],
	"./components/IframeErrorAlert/index": [
		970,
		9,
		51
	],
	"./components/IframeErrorAlert/index.tsx": [
		970,
		9,
		51
	],
	"./index": [
		312,
		9
	],
	"./index.tsx": [
		312,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1257;
module.exports = webpackAsyncContext;